import apiFetch from '../core/apiFetch';
import { EligibleMember, EligibleMemberApi } from '../../interfaces/monikers';
import { checkStatus, handleError } from '../../utils/api';
import { UNEXPECTED_ERROR } from '../../constants/errors';
import { getAuthTokenAsync } from '../../utils/authToken';

const mapEligibleMember = (values: EligibleMemberApi): EligibleMember => {
  const {
    id,
    email,
    zip,
    gender,
    birthdate,
    first_name: firstName,
    last_name: lastName,
    affiliation_id: affiliationId,
  } = values;
  const [dobYear, dobMonth, dobDay] = birthdate.split('-');
  return {
    id,
    firstName,
    lastName,
    affiliationId,
    email,
    zip,
    gender,
    dobDay,
    dobMonth,
    dobYear,
  };
};

export interface SuccessResponse {
  monikerCheck: {
    eligibleMember: EligibleMember;
  };
}

export interface ErrorResponse {
  error: {
    code: string;
    payload: null;
  };
}

const getMonikerCheckAsync = async (
  monikerCheckId: string
): Promise<SuccessResponse | ErrorResponse> => {
  const url = `api/v1/moniker_checks/${monikerCheckId}`;

  try {
    const authToken = await getAuthTokenAsync();
    const response = await apiFetch(authToken, url, { method: 'GET' });

    await checkStatus(response);

    const {
      moniker_check: { eligible_member: eligibleMember },
    } = await response.json();

    return {
      monikerCheck: {
        eligibleMember: mapEligibleMember(eligibleMember),
      },
    };
  } catch (error) {
    handleError('unexpected status - v2 eligibility check', error);
    return { error: { code: UNEXPECTED_ERROR, payload: null } };
  }
};

export default getMonikerCheckAsync;
